import CallCentreApi from '@/api/CallCentreApiAxiosPlugin'
import { JobPermissionsResponse } from '@/api/models/jobs/job-permissions-response'
import JobSearchIndexModel from '@/models/JobSearchIndexModel'
import { AxiosError, AxiosResponse } from 'axios'
import JobPolicyDetailsResponse from './models/jobs/JobPolicyDetailsResponse'
import { ClaimSummary } from '@/models/claimSummaries/claim-summary'

export type SearchFilter = {
  type: 'ClientId' | 'ContractorId' | 'JobType' | 'PolicyNumber'
  value: string
}

export default class JobsController {
  public static async GetJobPermissionsAsync(jobId: string): Promise<JobPermissionsResponse> {
    const apiResponse = await CallCentreApi.get<JobPermissionsResponse>(`jobs/${jobId}/permissions`)

    const response = new JobPermissionsResponse()
    response.canChangeContactDetails = apiResponse.data.canChangeContactDetails
    response.canTakeManualPayments = apiResponse.data.canTakeManualPayments

    return response
  }

  public static async SearchJobs(
    searchKeyword: string,
    filters: (SearchFilter | undefined)[] = []
  ): Promise<JobSearchIndexModel[]> {
    const keyword = searchKeyword.toLowerCase().trim()
    const sanitizedFilters = filters
      .filter((filter): filter is SearchFilter => !!filter)
      .map((filter) => {
        filter.value = String(filter.value)
        return filter
      })

    const res: AxiosResponse = await CallCentreApi.post<JobSearchIndexModel[]>(`jobs/search`, {
      searchText: keyword,
      filters: sanitizedFilters,
    })
    return res.data || []
  }

  public static async GetPolicyDetails(jobId: string): Promise<JobPolicyDetailsResponse> {
    const res = await CallCentreApi.get<JobPolicyDetailsResponse>(`jobs/${jobId}/policy`)
    return res.data
  }

  public static async StartSummary(jobId: string): Promise<boolean> {
    const { status } = await CallCentreApi.post<boolean>(`jobs/${jobId}/start-summary`)
    return status === 202
  }

  public static async GetLatestSummary(jobId: string): Promise<ClaimSummary | null> {
    try {
      const { status, data } = await CallCentreApi.get<ClaimSummary>(`jobs/${jobId}/summary/latest`)
      return status === 200 ? data : null
    } catch (error) {
      if (error instanceof AxiosError && error.response?.status === 404) {
        return null
      }
      throw error
    }
  }
}
